import axios from "axios";
import storage from "./storage.service";
import config from "../config";
import storageService from "./storage.service";
import queryStringHelper from 'query-string';

const tokenKey = config.TOKEN_KEY;
// const refreshTokenKey = config.REFRESH_TOKEN_KEY;
const baseURL = config.SERVER_API;

const http = axios.create({ baseURL: `${baseURL}` });

const errorHandler = (e) => {
	if (e.response.status === 401) {
		// const refreshToken = storage.getItem(refreshTokenKey);
		//
		// http.post('/accounts-api/token', { 'refresh_token': refreshToken })
		// 	.then(res => {
		// 		storage.setItem(tokenKey, res.id_token);
		// 		storage.setItem(refreshTokenKey, res.refresh_token);
		//
		// 		return http.request({
		// 			...lastCalledApi,
		// 			headers: {
		// 				...lastCalledApi.headers,
		// 				Authorization: `Bearer ${res.id_token}`,
		// 			}
		// 		})
		// 	})
		// 	.catch(e => console.log(e))
		storageService.removeItem(tokenKey);
		 window.location.href = "/auth/login";
	} else  {
		throw (e);
	}
};

function get(url, headers = {}, params = {}) {
	const accessToken = storage.getItem(tokenKey);
	const authHeader = { Authorization: `Bearer ${accessToken}` };

	let queryString;
	queryString = queryStringHelper.stringify(params.params, { encode: false, arrayFormat: "none" });
	if (queryString) {
		queryString = "?" + queryString;
		params = {};
	}

	return http.get(`${url}${queryString}`, {
		...params,
		headers: { ...authHeader, ...headers },
	}).catch(e => errorHandler(e));
}

function post(url, data, headers = {}, params = {}) {
	const accessToken = storage.getItem(tokenKey);
	const authHeader = { Authorization: `Bearer ${accessToken}` };

	return http.post(url, data, {
		...params,
		headers: { ...authHeader, ...headers },
	}).catch(e => errorHandler(e));
}

function put(url, data, headers = {}) {
	const accessToken = storage.getItem(tokenKey);
	const authHeader = { Authorization: `Bearer ${accessToken}` };

	return http.put(url, data, {
		headers: { ...authHeader, ...headers }
	}).catch(e => errorHandler(e));
}

function remove(url, data, headers = {}) {
	const accessToken = storage.getItem(tokenKey);
	const authHeader = { Authorization: `Bearer ${accessToken}` };

	return http.delete(url, {
		headers: { ...authHeader, ...headers },
		data,
	}).catch(e => errorHandler(e));
}

export default {
	http,
	get,
	post,
	put,
	remove,
};
